import { Pipe, PipeTransform } from '@angular/core';
import { FavouriteLanguage } from 'src/types/graphql';

@Pipe({
  name: 'language',
  standalone: true,
})
export class LanguagePipe implements PipeTransform {
  transform(lang: FavouriteLanguage | string, short?: boolean): string {
    switch (lang) {
      case FavouriteLanguage.It:
        return 'Italiano IT'.split(short ? ' ' : '#')[0];
      case FavouriteLanguage.En:
        return 'English EN'.split(short ? ' ' : '#')[0];
      case FavouriteLanguage.Es:
        return 'Español ES'.split(short ? ' ' : '#')[0];
      case FavouriteLanguage.Fr:
        return 'Français FR'.split(short ? ' ' : '#')[0];
      case FavouriteLanguage.De:
        return 'Deutsch DE'.split(short ? ' ' : '#')[0];
      default:
        return '';
    }
  }
}
